// @flow
import React, { Component } from 'react';
import { NavLink, Redirect } from 'react-router-dom';
import { Input, Menu } from 'semantic-ui-react';
import type { Match, LocationShape } from 'react-router-dom';

type Props = {
    clientId: Guid,
    data: { name: string, path: LocationShape }[],
    getData: () => Promise<void>,
    match: Match,
    disabled: boolean
};
class SubMenu extends Component<Props, { search: string }> {
    state = { search: '' };
    componentDidMount() {
        this.getData();
    }
    componentDidUpdate(prevProps: Props) {
        if (this.props.clientId !== prevProps.clientId) {
            this.getData();
        }
    }
    getData() {
        this.props.getData().then(data => this.setState({ search: '' }));
    }
    render() {
        return (
            <Menu.Menu
                disabled={this.props.disabled}
                style={{
                    transition: 'max-height 5s ease-out',
                    maxHeight: this.props.data.length ? '100em' : 0,
                    overflow: 'hidden'
                }}
            >
                {this.props.data.map(el => (
                    <Menu.Item as={NavLink} content={el.name} key={el.path.pathname} to={el.path} />
                ))}
            </Menu.Menu>
        );
    }
}

export default SubMenu;



// WEBPACK FOOTER //
// ./components/molecules/SubMenu.jsx